"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const AbstractGroupedDropdown_1 = tslib_1.__importDefault(require("./AbstractGroupedDropdown"));
/**
 * @deprecated Use {@link GroupedDropdownWidget} instead.
 */
class AbstractLabelledGroupedDropdown extends AbstractGroupedDropdown_1.default {
    constructor(model, label) {
        super(model);
        const elementWrapper = document.createElement("div");
        const oldElement = this.element;
        this.element = elementWrapper;
        this.element.classList.add("dropdown-container-with-label-container");
        const labelElement = document.createElement("label");
        const labelId = fmko_ts_common_1.GlobalCounter.next();
        labelElement.textContent = label;
        labelElement.id = labelId;
        this.dropdownButton.setAttribute(fmko_ts_common_1.ARIA.LABELLED_BY, `${labelId} ${this.dropdownButton.id}`);
        this.element.appendChild(labelElement);
        this.element.appendChild(oldElement);
    }
}
exports.default = AbstractLabelledGroupedDropdown;
//# sourceMappingURL=AbstractLabelledGroupedDropdown.js.map